<div class="mb-3" *ngIf="funds?.length >0">
    <p-table  #dt [value]="funds" >
        <ng-template pTemplate="header">
            <tr>
                <th scope="col">
                    <input 
                    class="cursor"
                    type="checkbox" 
                    [checked]="isAllSelected()"  
                    (change)="toggleSelectAll($event)" />
                    <span class="all-style">All</span>
                </th>
                <th  scope="col" >
                    Fund Family
                </th>
                <th  scope="col" >
                    Status
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fund let-rowIndex="rowIndex">
            <tr>
                <td> <input 
                    class="cursor"
                    type="checkbox" 
                    [(ngModel)]="fund.selected" 
                    (ngModelChange)="onCheckboxChange(fund)" />
                </td>
                <td>{{fund.name}}</td>
                <td>{{fund.status}}</td>
            </tr>
        </ng-template>
        
    </p-table>
</div>